var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "div",
          { staticClass: "calculator", class: _vm.getCalcPanelClass() },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col rbcalc-mb-4" },
                [
                  _c(
                    "error-boundary",
                    [
                      _c("control-range", {
                        attrs: {
                          label: "Сумма кредита",
                          "external-key": "amount",
                          "measure-unit-title": _vm.getCurrencyMeasureUnitTitle,
                          params: _vm.getAmountRange,
                          "external-handler": _vm.setData,
                          "default-value": _vm.getUserInputByKey("amount")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "error-boundary",
              [
                _c("control-range", {
                  staticClass: "rbcalc-mb-4",
                  attrs: {
                    label: "Срок кредита",
                    "external-key": "term",
                    params: _vm.getTermsRange,
                    "external-handler": _vm.setTerm,
                    "is-month-to-years": true,
                    "default-value": _vm.getUserInputByKey("numberOfPayments")
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row col" },
              [
                _vm.getInsuranceToggle
                  ? _c("control-checkbox", {
                      attrs: {
                        label: "Включить страховку в стоимость",
                        "external-key": "insurance",
                        "external-handler": _vm.setData,
                        "default-value": _vm.getUserInputByKey("insurance")
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row d-none d-lg-block d-xl-block " }, [
              _c("div", { staticClass: "col disclaimer__left" }, [
                _vm._v("\n          " + _vm._s(_vm.disclaimer) + "\n        ")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.getUserInputByKey("twoRates")
          ? [
              _c("div", { staticClass: "result-spacer d-lg-none" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-lg-5 result-loan",
                  class: _vm.getResultPanelClass()
                },
                [
                  _c("div", { staticClass: "row ie-fix" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-2 col-sm-3 col-md-3 col-lg-3 result__col-title-left"
                      },
                      [
                        _c(
                          "error-boundary",
                          [
                            _c(
                              "block-legend",
                              {
                                attrs: {
                                  "class-names":
                                    "legend__value_small-2 legend__value_block"
                                }
                              },
                              [_c("span", [_vm._v("1-й год")])]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "spacer" }),
                        _vm._v(" "),
                        _c(
                          "error-boundary",
                          [
                            _c(
                              "block-legend",
                              {
                                attrs: {
                                  "class-names":
                                    "legend__value_small-2 legend__value_block"
                                }
                              },
                              [_c("span", [_vm._v("со 2-го года")])]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-5 col-sm-6 col-md-6 col-lg-5 result__col-first"
                      },
                      [
                        _c(
                          "error-boundary",
                          [
                            _c(
                              "block-legend",
                              {
                                attrs: {
                                  "class-names": "legend__value_small-1"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "result__col-title-top" },
                                  [_vm._v("Ежемесячный платеж")]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "error-boundary",
                          [
                            _c("block-legend", {
                              attrs: {
                                value: _vm.total("getTotal"),
                                "class-names":
                                  "legend__value_medium-2 legend__value_block-center"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "spacer" }),
                        _vm._v(" "),
                        _c(
                          "error-boundary",
                          [
                            _c("block-legend", {
                              attrs: {
                                value: _vm.total("getSecondYearTotal"),
                                "class-names":
                                  "legend__value_medium-2 legend__value_block-center"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.showRate
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-5 col-sm-3 col-md-3 col-lg-4 result__col-second"
                          },
                          [
                            _c(
                              "error-boundary",
                              [
                                _c(
                                  "block-legend",
                                  {
                                    attrs: {
                                      "class-names": "legend__value_small-1"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "result__col-title-top" },
                                      [_vm._v("Ставка")]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "error-boundary",
                              [
                                _c("block-legend", {
                                  attrs: {
                                    value: _vm.rate("getRate"),
                                    "class-names":
                                      "legend__value_medium-2 legend__value_block-center"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "spacer" }),
                            _vm._v(" "),
                            _c(
                              "error-boundary",
                              [
                                _c("block-legend", {
                                  attrs: {
                                    value: _vm.rate("getSecondYearRate"),
                                    "class-names":
                                      "legend__value_medium-2 legend__value_block-center"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "schedule-wraper col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      },
                      [
                        _vm.isShowingCtaButtonControl
                          ? _c(
                              "error-boundary",
                              [
                                _c("control-button", {
                                  staticClass: "button--primary",
                                  attrs: {
                                    text: _vm.getCtaText,
                                    "external-handler": _vm.ctaHandler
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShowingDetailsButtonControl
                          ? _c(
                              "error-boundary",
                              [
                                _c(
                                  "control-button",
                                  {
                                    staticClass: "button--text",
                                    attrs: {
                                      text: _vm.getDetailsText,
                                      "external-handler": _vm.detailsHandler
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "button--icon fa fa-arrow-right"
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        !_vm.getUserInputByKey("twoRates")
          ? _c("div", { staticClass: "col-lg-5 result" }, [
              _c("div", { staticClass: "row ie-fix" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "remove-pad col-xs-12 col-sm-auto col-md-12 col-lg-12"
                  },
                  [
                    _c(
                      "error-boundary",
                      [
                        _c(
                          "block-legend",
                          {
                            staticClass: "sum-value",
                            attrs: {
                              "external-key": "total",
                              description: "Ежемесячный платеж",
                              value: _vm.total("getTotal")
                            }
                          },
                          [
                            _vm._v(
                              "\n              Ежемесячный платеж\n            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.showRate
                      ? [
                          _c(
                            "error-boundary",
                            [
                              _c(
                                "block-legend",
                                {
                                  attrs: {
                                    "external-key": "rate",
                                    value: "от " + _vm.rate("getRate")
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Ставка по кредиту\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "remove-pad col-xs-12 col-sm-12 col-md-12 col-lg-12"
                  },
                  [
                    _vm.isShowingCtaButtonControl
                      ? _c(
                          "error-boundary",
                          [
                            _c("control-button", {
                              staticClass: "button--primary",
                              attrs: {
                                "external-key": "cta_btn",
                                text: _vm.getCtaText,
                                "external-handler": _vm.ctaHandler
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowingDetailsButtonControl
                      ? _c(
                          "error-boundary",
                          [
                            _c(
                              "control-button",
                              {
                                staticClass: "button--text",
                                attrs: {
                                  "external-key": "details_btn",
                                  text: _vm.getDetailsText,
                                  "external-handler": _vm.detailsHandler
                                }
                              },
                              [
                                _c("span", {
                                  staticClass: "button--icon fa fa-arrow-right"
                                })
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row d-lg-none " }, [
      _c("div", { staticClass: "col disclaimer" }, [
        _vm._v("\n      " + _vm._s(_vm.disclaimer) + "\n    ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }